export default __webpack_public_path__ + "fb7ddc74366e01170cd4467d6c87e011.svg";